import { Link } from 'react-router-dom';
import { DocumentState } from '../../types/document-state';

interface Props {
  id: string;
  name: string;
  description: string;
  state: DocumentState;
}

const BORDER_COLOR = {
  [DocumentState.EMPTY]: 'border-zinc-400 text-zinc-400',
  [DocumentState.IN_PROGRESS]: 'border-primary-500 text-primary-500',
  [DocumentState.SUBMITTED]: 'border-primary-400 text-primary-400',
  [DocumentState.ACCEPTED]: 'border-black'
};

export default function AttachmentCard({ id, name, description, state }: Props) {
  return (
    <Link to={`attachment/${id}`}>
      <div
        className={`attachments-card relative py-3 px-2 bg-white border-2 ${BORDER_COLOR[state]} border-gree rounded
        hover:shadow-md animate-fadeIn`}
      >
        <div className="text-xl text-center">{name}</div>
      </div>
    </Link>
  );
}
